var $cc7e1ea6b8590e7d$exports = {};
$cc7e1ea6b8590e7d$exports = {
    "info": `\u{C815}\u{BCF4}`,
    "negative": `\u{C624}\u{B958}`,
    "notice": `\u{ACBD}\u{ACE0}`,
    "positive": `\u{C131}\u{ACF5}`
};


export {$cc7e1ea6b8590e7d$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
